import React from 'react';
import { useSelector } from 'react-redux';
import ExerciseVideoThumbnail from './ExerciseVideoThumbnail';
import SuggestedSwaps from './SuggestedSwaps';

function ExercisePreview({
    exercise,
    hideDelete,
    horizontal,
    isLast,
    block,
    dispatch,
    position
}) {
    const swapExercises = useSelector(state => {
        if (
            exercise === null ||
            exercise === undefined ||
            !exercise.exercise_id
        )
            return [];
        const libraryExercise = state.library.exerciseRef.find(
            e => e.id === exercise.exercise_id
        );
        return libraryExercise && libraryExercise.swaps
            ? libraryExercise.swaps
            : [];
    });
    return (
        <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
            <ExerciseVideoThumbnail
                exercise={exercise}
                hideDelete={hideDelete}
                isLast={isLast}
                horizontal={horizontal}
                block={block}
                dispatch={dispatch}
                position={position}
            />
            <SuggestedSwaps swapExercises={swapExercises} />
        </div>
    );
}

export default ExercisePreview;



// WEBPACK FOOTER //
// ./src/view/designer/components/Exercise/ExercisePreview.jsx